<template>
    <div class="v-password-change">
        <hua-form :label-width="120" :input-align="'right'">
            <hua-field v-model="userName" label="手机号" placeholder="请输入" type="number" />
            <hua-field v-model="password" label="旧密码" placeholder="请输入" />
            <hua-field
                v-model="newPassword"
                label="新密码"
                placeholder="请输入"
                @blur="validatePassword"
            />
        </hua-form>
        <div class="v-submit-btn">
            <hua-button type="primary" block round @click="changePassword">确 认</hua-button>
        </div>
    </div>
</template>
<script>
import api from '@/constants/api'

export default {
    data() {
        return {
            userName: '',
            password: '',
            newPassword: '',
            passReg: /^[a-zA-Z0-9]$/,
        }
    },
    methods: {
        changePassword() {
            let params = {
                userName: this.userName,
                password: this.password,
                newPassword: this.newPassword,
            }
            this.validatePassword()
            api.changePassword(params)
                .then((res) => {
                    if (res.success) {
                        this.$toast('修改成功')
                        this.$router.push({ path: '/index' })
                    }
                })
                .catch((err) => {
                    this.$toast(err.errMsg)
                })
        },
        validatePassword() {
            if (!this.newPassword) {
                return this.$toast('请输入新密码')
            } else if (!this.passReg.test(this.newPassword)) {
                return this.$toast('密码仅支持数字和字母')
            }
        },
    },
}
</script>

<style lang="less">
.v-password-change {
    .v-submit-btn {
        margin: 50px 20px 20px;
    }
}
</style>